import { Printer } from 'lucide-react';
import { guideSections } from './helpDeskGuideContent';

export function HelpDeskGuidePrint() {
  return (
    <div className="min-h-screen bg-white p-6 print:p-0">
      <style>{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 12mm;
          }

          .print-toolbar {
            display: none !important;
          }

          .print-card {
            break-inside: avoid;
            page-break-inside: avoid;
          }
        }
      `}</style>

      <div className="print-toolbar mx-auto mb-6 flex max-w-6xl justify-end">
        <button
          type="button"
          onClick={() => window.print()}
          className="inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white hover:bg-slate-800"
        >
          <Printer className="h-4 w-4" /> PDF / Yazdir
        </button>
      </div>

      <div className="w-full space-y-6">
        <section className="rounded-3xl border border-slate-200 bg-white p-8">
          <h1 className="text-3xl font-bold text-slate-900">Yuk Ortagim PDF Export Rehberi</h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">Bu surum baski ve PDF export amacli duzenlenmistir. Icerik uygulama icindeki rehber ile aynidir ve tum ana modul pencerelerini kapsar.</p>
        </section>

        {guideSections.map((section) => (
          <section key={section.id} className="print-card rounded-3xl border border-slate-200 bg-white p-6">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Bolum {section.number}</div>
            <h2 className="mt-2 text-2xl font-bold text-slate-900">{section.title}</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">{section.summary}</p>

            <div className="mt-5 grid gap-4 md:grid-cols-2">
              <div>
                <div className="text-sm font-semibold text-slate-900">Kapsanan Moduller</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {section.modules.map((item) => <span key={item} className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-700">{item}</span>)}
                </div>
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">Erisim Yollari</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {section.paths.map((item) => <code key={item} className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-700">{item}</code>)}
                </div>
              </div>
            </div>

            <div className="mt-5 grid gap-4 md:grid-cols-2">
              <div>
                <div className="text-sm font-semibold text-slate-900">Kullanici Gorevleri</div>
                <ul className="mt-2 space-y-2 text-sm text-slate-700">
                  {section.tasks.map((item) => <li key={item}>• {item}</li>)}
                </ul>
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">Help Desk Notlari</div>
                <ul className="mt-2 space-y-2 text-sm text-slate-700">
                  {section.support.map((item) => <li key={item}>• {item}</li>)}
                </ul>
              </div>
            </div>

            {section.visuals?.length ? (
              <div className="mt-5 grid gap-4 md:grid-cols-2">
                {section.visuals.map((visual) => (
                  <figure key={visual.image} className="rounded-2xl border border-slate-200 p-3">
                    <img src={visual.image} alt={visual.imageAlt} className="w-full rounded-xl border border-slate-200" />
                    <figcaption className="mt-2 text-xs text-slate-500">{visual.caption}</figcaption>
                  </figure>
                ))}
              </div>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
}
